import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout } from "../components/LegalLayout";
import {
  APP_NAME, SUPPORT_EMAIL, LEGAL_ROUTES, LEGAL_INFO,
} from "../lib/legal";

function Section({ title, children }) {
  return (
    <section style={{ marginTop: 26 }}>
      <h2 style={{
        margin: "0 0 10px",
        fontSize: 20,
        fontWeight: 700,
        color: "var(--mf-text)",
        letterSpacing: -0.2,
      }}>
        {title}
      </h2>
      {children}
    </section>
  );
}

function P({ children, style }) {
  return <p style={{ margin: "0 0 12px", ...style }}>{children}</p>;
}

// Public legal mentions — no placeholder, no personal data of the editor.
// Wording aligned with the editor's decisions (anonymised publisher,
// prudent host wording, French law with consumer-protection reserve).
export default function LegalMentions() {
  return (
    <LegalLayout
      title="Mentions légales"
      description={`Informations légales relatives à ${APP_NAME}.`}
      pathname={LEGAL_ROUTES.legal}
    >
      <P style={{ color: "var(--mf-text-secondary)", fontSize: 15 }}>
        Cette page rassemble les informations légales relatives à {APP_NAME}.
        Toutes les demandes officielles peuvent être adressées à{" "}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </P>

      <Section title="1. Éditeur du service">
        <P>{LEGAL_INFO.publisherStatement}</P>
        <P>
          Contact public unique — support, questions légales et demandes
          relatives à vos données personnelles :{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </P>
        <P style={{ color: "var(--mf-text-secondary)", fontSize: 14 }}>
          {APP_NAME} est actuellement une application gratuite, sans abonnement,
          sans achat intégré et sans publicité. Toute évolution ultérieure fera
          l&apos;objet d&apos;une information claire avant activation.
        </P>
      </Section>

      <Section title="2. Directeur de la publication">
        <P>
          Le directeur de la publication est l&apos;éditeur du service, dont
          l&apos;identité personnelle n&apos;est pas rendue publique afin de préserver
          sa vie privée. Toute demande officielle peut être adressée à{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </P>
      </Section>

      <Section title="3. Hébergement et infrastructure">
        <P>{LEGAL_INFO.hostStatement}</P>
        <P>
          Contact relatif à la confidentialité chez ce fournisseur :{" "}
          <a href={`mailto:${LEGAL_INFO.hostPrivacyContact}`}>{LEGAL_INFO.hostPrivacyContact}</a>.
        </P>
        <P>
          Documents publics du fournisseur d&apos;hébergement :{" "}
          <a
            href={LEGAL_INFO.hostTermsUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            Conditions d&apos;utilisation Emergent
          </a>{" "}·{" "}
          <a
            href={LEGAL_INFO.hostPrivacyUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            Politique de confidentialité Emergent
          </a>.
        </P>
      </Section>

      <Section title="4. Propriété intellectuelle">
        <P>
          {APP_NAME}, sa marque, son identité visuelle, ses interfaces et son
          code appartiennent à son éditeur. Toute reproduction, représentation
          ou exploitation sans autorisation préalable est interdite. Les
          composants open source utilisés restent régis par leurs licences
          respectives.
        </P>
        <P>
          Les contenus que vous ajoutez dans {APP_NAME} (informations de
          véhicules, documents, images, notes) restent votre propriété. Vous
          nous accordez uniquement les droits techniques nécessaires à leur
          stockage et à leur affichage dans le cadre du service.
        </P>
      </Section>

      <Section title="5. Droit applicable et litiges">
        <P>{LEGAL_INFO.applicableLaw}</P>
      </Section>

      <Section title="6. Confidentialité et suppression de compte">
        <P>
          Le fonctionnement détaillé des traitements de données est décrit sur
          la page <Link to={LEGAL_ROUTES.privacy}>Politique de confidentialité</Link>.
          La procédure de suppression de compte est expliquée sur la page{" "}
          <Link to={LEGAL_ROUTES.deleteAccount}>Suppression de compte</Link>.
        </P>
      </Section>

      <Section title="7. Contact">
        <P>
          Pour toute question, écrivez à{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </P>
      </Section>
    </LegalLayout>
  );
}
